'use client';

export { Title } from '@paypoteam/ui-components';
